import React from 'react'
import styled from '@emotion/styled'
import { Transition } from 'react-transition-group'
import { rgba } from 'polished'
import { fbTrack } from 'src/utils/tracking'
import Grid from 'src/components/Grid'
import Slideshow from 'src/components/Slideshow'
import OptionValues from 'src/components/OptionValues'
import Modal from 'src/components/Modal'
import FooterNewsletterSignup from 'src/components/FooterNewsletterSignup'
import Input from 'src/components/Input'
import Button from 'src/components/Button'
import Collapse from 'src/components/Collapse'
import ContentfulRichText from 'src/components/ContentfulRichText'
import Img from 'gatsby-image'
import 'slick-carousel/slick/slick.css'
import { withShopifyContext } from 'src/state/ShopifyState'
import 'slick-carousel/slick/slick-theme.css'
import { colors, typography, animations, util, mq } from 'src/styles'
import { withCartContext, TABS } from 'src/state/CartState'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { formatPrice } from 'src/utils/format'
import { css } from '@emotion/core'

const Wrapper = styled.div``

const SlideshowContainer = styled.div`
	width: 100%;
	background: ${ colors.lightGrey };
	img {
		transition: opacity 1s ease-in-out !important;
	}
	> div,
	.slick-slider,
	.slick-list,
	.slick-track,
	.slick-slide {
		height: 100%;
	}
	.slick-slide > div {
		min-height: 100%;
	}
	.slick-arrow {
		${ mq.mediumAndBelow } {
			display: none !important;
			opacity: 0;
			pointer-events: none;
		}
		${ mq.largeAndUp } {
			height: 100%;
			width: 50%;
			transform: none;
			opacity: 0;
			transition: opacity 0.3s ease-in-out;
			z-index: 1;
			svg {
				display: none;
			}
			&.slick-next {
				right: 0;
				top: 0;
				bottom: 0;
				&:hover {
					cursor: -webkit-image-set(
								url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAjCAYAAAAt4qxQAAAABGdBTUEAALGPC/xhBQAAAVZJREFUaAXl2rFOAkEQBuCZO6ItnU/AE2BxBYlga2NCYU+B0h08AOppz7U8hAWllZQ0xAfwCXgFEm7cLUwgBLjb3QTzz5Sbnc3Ol9liN0sEEqP3QRKilDjEIudeY5Q99QopZknnur74Wn767CfySf4vuQZjRcRrEknT7HHisy+IDlnMlz9Ju/lNzF2D0kpu3TsFAsR2RCgUGJBQKFAgIVDgQHxRIEF8UGBBXFGgQVxQ4EGqoqgAqYKiBqQsiiqQMijqQE6h8DAb3Ahv2naivuAGCz2ISM1cDPN8PB1y+tZ/poJe9GHsV8zE9zWWeC7RRinIbodMxtMZ7zvpGElf+3fmmHyY95PLv+NiK1cJcghDJcgxDHUgpzBUgZTBUANSFkMFSBUMeJCqGNAgLhiwIK4YkCA+GHAgvhhQICEwYEBCYVgQiO8QEUdXRHKxfWu1xamOUD+IfgHWzSU4T01eJQAAAABJRU5ErkJggg==")
									1x,
								url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAABGCAYAAAAXWNyWAAAABGdBTUEAALGPC/xhBQAAAylJREFUeAHt3L9qFFEYBfC5yYLlVhYLVuIz2NhYCWmEPEIghKiNwTphYgpLexHyCAFLG+1s9A3E1sJKrJR1rjPB4E2yM3v/f+fDkyLZnbkzc/Y7Pybb7DYNfziBiQmYiX3cJTCBZ8ePtjrTPZwfLp60pu0EIly65MalZ3wiOoEBx2/TnVlr978///q6ta14P7yDiJL4d/GDk70H1po3jbU3LraaxpzOjxa7kncScaEXw/jv/85mX3oc39w52MbuSN9JeAdxGxF+fPDi8R37a/muj3HLjSJ5JyEQtwmAx2hICAQAxdUISEgI5Go7IM9RkBAICIhVMRCQEMiqZoC2SSMhECAMY1EkkRDIWCtg26WQEAgYhKk4EkgIZKoRwH21kRAIIIJ1kWoiIZB1bYDur4WEQEAB+MSqgYRAfJoAXlMaCYEAl+8brSQSAvFtAXxdKSQEAl58SLwSSAgkpAEFa3MjIRAFpYdGzImEQEKnr2R9LiQEoqTwmJg5kBBIzOQVHZOKhEAUlR0bNQUJgcROXdlxsUgIRFnRKXFjkBBIysQVHhuKhEAUlpwaOQQJgaROW+nxvkjOgTw93rNKXydjF5iA+1ngWYHz85TKJ/D3WwWa/vtJdvn1D8rLLB2fQEpPWOH53X8xfJOqsMAckYPepOa4IM+hZwK+OIZXxDuInl6zJA3BQSBZRq7nJKE4CERPt8lJY3AQSPLYdZwgFgeB6Og3KWUKDgJJGj3+wak4CAS/4+iEOXAQSPT4sQ/MhYNAsHuOSpcTB4FEVYB7UG4cBILbdXCyEjgIJLgGzANK4SAQzL6DUpXEQSBBVeAtLo2DQPA6905UAweBeNeBtbAWDgLB6t0rTU0cBOJVCc6i2jgIBKf7tUkkcBDI2lowFkjhIBCM/idTSOIgkMlq5HdK4yAQeQOjCRBwEMhoPbI7UHAQiKyDlVdHwkEgKyuS24iGg0DkLFy7MiKOISQ/3X+tKqENy+Xtxpib7tXdT9m722s+JpCa05641svDV2837cZ2j+TnsAwBx5Bjc/jFH4wJfHj/8fO9+3c/9Tp+zI8W+61pO4xkTMEJjEzgD4DNUenwE4jGAAAAAElFTkSuQmCC")
									2x
							)
							33 16,
						auto;
				}
			}
			&.slick-prev {
				left: 0;
				top: 0;
				bottom: 0;
				&:hover {
					cursor: -webkit-image-set(
								url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAjCAYAAAAt4qxQAAAABGdBTUEAALGPC/xhBQAAAWBJREFUaAXt2j1uwjAUB/D3gtSZjYO0Q4YOFSdA4gYM/dgo3dsK2MlKb9CpU4dOZapYUA/QE3AEENi1gSAQCdgxQ+S/PSSD4ye/X5zItkx0htLpP8RnCFOKEJFrL9rdu4EQy59O977lGqsM7Z1ANAZJ2SbiuZBiWoaEXPvARQNsMZhnCqWZvLx9Fo1VpnaFQHzF0C/GGsRnDGsQ3zGsQBAwjEFQMIxAkDBOgqBhHAVBxMgFQcXIBEHGOABBx9gDCRiaYzN138FYqMn8O5H8W1djXVlWRvzUu20sBX1gpZ6TbUSvq8VdGCFroNUISa12ULza30jzM71X0gfH35OvuH5VVZs918TcjG8uf8ejCdy/ZAuiYQIK0R5IQMkAQUc5GCEaRBfUzycXBBXlKAgiykkQNBQjECQUYxAUFCsQBBRrEN9RCoH4jOJ0HCJ5Hj6qhWCiNpQuIo5qGioUJeDTCaJ/dPBLI7QMhWgAAAAASUVORK5CYII=")
									1x,
								url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAABGCAYAAAAXWNyWAAAABGdBTUEAALGPC/xhBQAAAyZJREFUeAHt3K+OFEEQBvDp2Q0WhcBi0BgMBiSGhEcgQYBGIY5bOE0Ww5FsSHgEEgzJKRyGRyAokhMo5CXHNtkTk9vdmZ7+U9VVNfeh7na6e2q+75dj1TQN/iGBQAKzwLVqlxZ+0d6Z3T6+d//u+vu3Hz+r3Rg3Gk2gHV3BvGCD4++b04/e+2f/3Przi9fPHzLfEscnJOAS1pIv7XA0/kl3uHNnzvlHy4PVSfcZfhBLQOwvSC+OTQze/2nm819iieDGWwmI/AUZxNE0v921+YPly2N8D9mqSe6X6kCAQ67snDtXBQIcORXJ7qkGBDhki869exUgwJFbj/w+diDAIV9yyQSsQICjpBode9mAAIeOgkunYAECHKW16NlPDgQ49JRLMQkpEOCgqETXGWRAgENXsVTTkAABDqo69J1TDAQ49JVKOVEREOCgrELnWdlAgENnodRTZQEBDuoa9J6XDAQ49JbJMVkSEODgqED3mdFAgEN3kVzTRQEBDq749Z87CgQ49JfIOWEQCHBwRm/j7EEgwGGjQO4pe4EAB3fsds7fAwIcdsqrMekWEOCoEbmte3RAgMNWcbWmvQASwFFrDtxHYQLvDleuBQ6FzSgaSez1D4oywCiBBNqFW6yvv7r51DXuU2AdLl3RBPAl9YoWH/vYHZDNhsD3EbzYJTbRia3bAgIkE2uX4HH2gAAJQaoTOqIXCJBMqOHCRxkEAiSFyU5kexAIkEyk5YLHGAUCJAXpTmBrFBAgmUDTmY8QDQRIMhM2vi0JCJAYbztj/GQgQJKRsuEtWUCAxHDjiaNnAwGSxKSNLi8CAiRGW08YuxgIkCSkbXApCRAgMdh85MhkQIAkMnFjy0iBAImx9iPGJQcCJBGpG1rCAgRIDAkYGZUNCJCMJG/kMisQIDGiIDAmOxAgCaRv4FIVIEBiQMLAiNWAAMlAA8o/rgoESJRr6BmvOhAg6WlB8UciQIBEsYid0cRe/zD4VgHnbjTn57d25sSvQgmIAdk87x4S585mvn28PFidCOWB2+4kIPZfzOU5Lt4qcHT6vvXtl7eHH75evoafkQASUJzAf4GGykMD/oNQAAAAAElFTkSuQmCC")
									2x
							)
							33 16,
						auto;
				}
			}
		}
	}
	.slick-dots {
		mix-blend-mode: difference;
		z-index: 1;
		bottom: 25px;
		text-align: right;
		padding-right: 25px;
		li {
			margin: 0;
			button {
				position: relative;
				font-size: 0;
				text-indent: -20px;
				overflow: hidden;
				&:hover {
					&:before {
						opacity: 1;
					}
				}
				&:before {
					position: absolute;
					top: 50%;
					left: 50%;
					border-radius: 50%;
					margin: -4px;
					color: white;
					content: "";
					display: block;
					font-size: 12px;
					transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
					opacity: 0.3;
					width: 8px;
					height: 8px;
					background: white;
					transform: scale(0.5);
				}
			}
		}
		li.slick-active button:before {
			transform: scale(1);
			opacity: 1;
		}
	}
	${ mq.largeAndUp } {
		.slick-slider {
			.slick-list {
				.slick-track {
					.slick-slide > div {
						height: 100vh;
						display: flex;
						background-size: cover;
						background-repeat: no-repeat;
						img {
							object-fit: cover;
							height: 100%;
						}
					}
				}
			}
		}
	}
`

const ProductInfoContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-content: center;
	justify-content: center;
	${ util.responsiveStyles('padding-top', 100, 56, 52, 26) }
	${ util.responsiveStyles('padding-bottom', 100, 56, 52, 32) }
`

const RowCollapse = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	margin-bottom: 16px;
	${ mq.smallAndBelow } {
		flex-direction: column;

	}}
`
const Title = styled.div`
	${ typography.h4 }
	padding-right: 15px;
	padding-bottom: 5px;
`

const Price = styled.div`
	color: ${ colors.lightTextColor };
	${ typography.body }
`

const Hr = styled.hr`
	margin: 0;
`
const DetailTitle = styled.div`
	${ typography.h6 }
	line-height: 1em;
	padding-bottom: 2px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	${ mq.mediumAndBelow } {
		min-height: auto;
		margin-bottom: 4px;
	}
	svg {
		transition: color ${ animations.mediumSpeed } ease-in-out,
			transform ${ animations.mediumSpeed } ease-in-out;
		margin: -6px 0 -8px;
	}
`

const DetailContent = styled.div`
	${ typography.bodySmall }
	padding-bottom: 3px;
	${ ({ listOnly }) =>
		listOnly
			? `
		h1, h2, h3, h4, h5, h6, blockquote, p {
			display: none;
		}
	`
			: `` }
	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		li {
			position: relative;
			padding-left: 1em;
			&:before {
				content: "";
				display: block;
				position: absolute;
				left: 0;
				top: 0.8em;
				margin-top: -3px;
				width: 6px;
				height: 6px;
				background: ${ rgba(colors.green, 0.4) };
				border-radius: 50%;
			}
		}
	}
	${ ({ type }) =>
		type === 'options'
			? `
		min-height: 48px;
		padding-bottom: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		${ mq.mediumAndBelow } {
			min-height: auto;
		}
	`
			: `` }
`

const DetailOptions = styled.div`
	${ typography.bodySmall }
	flex-grow: 0;
	flex-shrink: 0;
	display: flex;
	align-items: center;
`

const DetailsRow = styled.div`
	min-height: 48px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	border-bottom: 1px solid ${ colors.hrColor };
	${ ({ type }) =>
		type === 'options'
			? `
		padding: 0;
		${ mq.mediumAndBelow } {
			min-height: auto;
			padding: 14px 0 13px;
			${ DetailTitle } {
				margin-bottom: 8px;
			}
		}
	`
			: `
		padding: 10px 0;
		${ mq.mediumAndBelow } {
			padding: 14px 0 13px;
		}
	` }
`

const ButtonATC = styled(Button)`
	max-width: 160px;
	margin-top: 35px;
`

const SizeGuideLink = styled.a`
	display: inline-block;
	${ typography.h6 }
	${ util.responsiveStyles('font-size', 11, 11, 11, 11) }
	color: ${ colors.lightTextColor };
	border-bottom: 2px solid ${ colors.hrColor };
	&:hover {
		color: ${ colors.textColor };
		border-color: ${ colors.textColor };
	}
`

const Zoom = styled.div`
	z-index: 40;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	display: none;
	cursor: zoom-out;
	img {
		width: 100%;
		height: auto;
	}
	opacity: 0;
	pointer-events: none;
	${ ({ zoomed }) =>
		zoomed
			? `display: block; pointer-events: unset; opacity: 1; height: 100%`
			: '' }
`

const ProductDescription = styled.div`
	p {
		${ typography.body }
	}
	ul,
	ol {
		display: none;
	}
`

const ExpandDetailsRow = styled(Collapse)`
	width: 100%;
	padding: 0;
	p,
	ul,
	ol {
		${ typography.bodySmall }
	}
	${ DetailTitle } {
		padding: 10px 0;
		min-height: 48px;
	}
	.open {
		svg {
			transform: rotate(-180deg);
		}
	}
	> div {
		> div {
			padding-bottom: 12px;
		}
	}
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	border-bottom: 1px solid ${ colors.hrColor };
`

const SizeGuideModal = styled.div`
	position: fixed;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	button {
		position: absolute;
		${ util.responsiveStyles('top', 50, 40, 20, 20) }
		${ util.responsiveStyles('right', 50, 40, 20, 20) }
		z-index: 2;
		color: ${ colors.offwhite };
		&:hover {
			color: ${ colors.white };
		}
	}
	img {
		z-index: 2;
		position: absolute;
		object-fit: contain;
		width: 100%;
		height: 100%;
		max-width: 1200px;
		${ util.responsiveStyles('padding', 100, 80, 40, 20) }
		transition: opacity .5s ease-in-out;
		${ ({ transitionStatus }) => transitionStatus === 'entered' ? `
	    opacity: 1;
	  ` : `
	  	opacity: 0;
	  ` }
	}
`

const SizeChartModalOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	transition: opacity .5s ease-in-out;
	background: ${ colors.green };
	${ ({ transitionStatus }) => transitionStatus === 'entered' ? `
    opacity: .4;
  ` : `
  	opacity: 0;
  ` }
`

const SizeChartPanel = styled.div`
	width: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 100%;
	z-index: 2;
	overflow-y: auto;
	padding: ${ 100 / 14 }vw 0;
	> div {
		height: 100%;
	}
	${ mq.largeAndUp } {
		padding: ${ 100 / 28 }vw 0;
		width: 50%;
		min-width: 600px;
		max-width: 700px;
	}
	background: ${ colors.bgColor };
	transition: transform .5s ease-in-out;
	${ ({ transitionStatus }) => transitionStatus === 'entered' ? `
    transform: translate3d(-100%, 0, 0);
  ` : `
  ` }
  button {
  	color: ${ colors.lightTextColor };
  	&:hover {
  		color: ${ colors.textColor };
  	}
  }
`

const SizeChartPanelContent = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	.gatsby-image-wrapper {
		width: 200px;
		height: 200px;
		margin: 0 auto 40px;
		flex-grow: 0;
		flex-shrink: 0;
		img {
			padding: 0;
		}
		> div {
			display: none !important;
		}
	}
	h4 {
		text-align: center;
		margin: 0;
		flex-grow: 0;
		flex-shrink: 0;
		margin-bottom: 50px;
	}
	div {
		flex-grow: 0;
		flex-shrink: 0;
	}
`

const ShippingTextWrapper = styled.div`
	p {
		font-size: 12px;
	}
`

const SizeChart = styled(ContentfulRichText)`
	table {
		width: 100%;
		p {
			${ typography.bodySmall };
			margin: 0;
		}
		tr {
			border-bottom: 1px solid ${ colors.hrColor };
			td {
				padding: .5em;
			}
			&:first-of-type {
				text-align: center;
				border-color: ${ colors.textColor };
				p {
					${ typography.h6 }
				}
			}
			td:not(:first-of-type) {
				text-align: center;
			}
			td:first-of-type {
				padding-left: 0;
			}
		}
	}
`

const ButtonWrapper = styled.div`
	display: flex;
	// justify-content: space-between;

	${ mq.mediumAndBelow } {
		flex-direction: column;
	}

	> div {
		margin-left: 1em;
		margin-top: 35px;

		${ mq.mediumAndBelow } {
			margin-top: 16px;
			margin-left: 0;
		}
	}
`

const NotifyModalBody = styled.div`
	text-align: center;
	// padding: 32px;
	padding-bottom: 0;

	h2 {
		${ typography.h2 }
		margin-bottom: 32px;
		max-width: 15em;
	}

	input {
		margin-bottom: 24px;
		${ mq.largeAndUp } {
			margin-bottom: 48px;
		}
	}

	p {
		margin-bottom: 0;
	}
`

class ProductAboveTheFold extends React.Component {
	constructor (props) {
		super(props)
		this.state = {
			selectedVariant: null,
			selectedOptions: {},
			addToCartDisabled: false,
			zoomed: false,
			sizeGuideExpanded: false,
			refs: {},
			notifyModal: false,
			notifyEmail: null,
			notifyStatus: null,
			comingSoonModal: null
		}
	}

	toggleNotifyModal = () => {
		this.setState({ notifyModal: !this.state.notifyModal })
	}

	clearNotifyStatus = () => {
		this.setState({ notifyStatus: null })
	}
	clearNotifyEmail = () => {
		this.setState({ notifyEmail: null })
	}

	handleChange = event => {
		this.setState({ notifyEmail: event.target.value })
	}

	componentDidMount () {
		this.selectFirstVariant()
	}

	selectFirstVariant = () => {
		const { selectedVariant } = this.state
		if (selectedVariant) return
		const { product = {}, sizeGuideImage } = this.props
		const { variants } = product
		const firstVariant = variants[0]
		if (!firstVariant) return
		const selectedOptions =
			firstVariant &&
			firstVariant.selectedOptions.reduce(
				(acc, x) =>
					// map through first variant's selected options and build dictionary
					({
						...acc,
						[x.name]: x.value,
					}),
				{}
			)
		this.setState({
			selectedVariant: firstVariant,
			selectedOptions,
		})
		this.props.setVariant(firstVariant)
	}

	selectVariant = () => {
		const { selectedOptions } = this.state
		const { product = {} } = this.props
		const { variants } = product
		const newSelectedVariant = variants.find(variant => {
			let match = true
			variant.selectedOptions.forEach(({ name, value }) => {
				if (selectedOptions[name] !== value) match = false
			})
			return match
		})
		this.setState({ selectedVariant: newSelectedVariant })
		this.props.setVariant(newSelectedVariant)
	}

	handleSelectValue = (option, value) => {
		this.setState(
			{
				selectedOptions: {
					...this.state.selectedOptions,
					[option.name]: value,
				},
			},
			this.selectVariant
		) // callback
	}

	checkIfAvailable = (option, value) => {
		const { product = {} } = this.props
		const { variants } = product
		const selectedVariant = variants && variants.find(({ selectedOptions }) => (
			selectedOptions.find(x => x.value === value)
			))
		// return (selectedVariant && selectedVariant.available)
		return true
	}

	toggleSizeGuide = () => {
		this.setState({ sizeGuideExpanded: !this.state.sizeGuideExpanded })
	}

	handleAddToCart = () => {
		const { selectedVariant } = this.state
		const { shopifyContext = {}, cartContext = {}, product } = this.props
		const { addLineItemToCart } = shopifyContext
		const { toggleCart } = cartContext

		const productId = product.id
				.replace('gid://shopify/Product/', '')
		const variantId = selectedVariant.id
			.replace('gid://shopify/ProductVariant/', '')

		this.setState({ addToCartDisabled: true })
		addLineItemToCart({ variantId: selectedVariant.id })
			.then(() => this.setState({ addToCartDisabled: false }))
			.then(() => toggleCart(TABS.CART))
			.then(() => {
				fbTrack('track', 'AddToCart', {
					currency: 'USD',
					content_type: 'product_group',
					item_group_id: productId,
					content_ids: variantId
				})
			})
	}

	handleBackInStockNotify = email => {
		const { product } = this.props
		const { selectedVariant } = this.state

		if (window && window.BIS && window.atob && selectedVariant && product) {
			const options = {}

			const productId = product.id
				.replace('gid://shopify/Product/', '')
			const variantId = selectedVariant.id
				.replace('gid://shopify/ProductVariant/', '')

			window.BIS.create(email, variantId, productId, options).then(response => {
					if (response.status === 'OK') {
						this.setState({
							notifyStatus:
								'Thank you. We will let you know when this item is back in stock',
						})
					} else if (response.errors.base) {
						this.setState({
							notifyStatus:
								'You have already registered for a notification for this item.',
						})
					} else if (response.errors.email) {
						this.setState({ notifyStatus: response.errors.email[0] })
					}
				}
			)
		}
	}

	setComingSoonModal = open => {
		this.setState({ comingSoonModal: open })
	}

	zoom = ({ id }) => {
		this.setState({ zoomed: true }, () => {
			const image = document.getElementById(id + '_zoomed_id')
			image.scrollIntoView()
		})
	}

	getResizedImage = (image, size = 1200) => {
		const resizeShopImage = this.props.shopifyContext.resizeShopImage
		return resizeShopImage(image, { maxWidth: size, maxHeight: size })
	}

	render () {
		console.log('render')
		const {
			product,
			swatches,
			shippingText,
			materialDescription,
			careInstructions,
			shopifyContext = {},
			sizeGuideImage,
			sizeChart,
			status,
			sizeFitText,
			addToCartText,
			comingSoonModalHeadline,
			comingSoonModalText
		} = this.props
		const {
			selectedVariant,
			selectedOptions,
			addToCartDisabled,
			zoomed,
			sizeGuideExpanded,
			notifyModal,
		} = this.state
		console.log('props',this.props)
		console.log('state', this.state)
		let images = (product && product.images) || []
		const sizeGuide = 'SizeGuide'
		let price = selectedVariant && selectedVariant.price.amount
		price = formatPrice(price)
		const hasDetails =
			product &&
			product.descriptionHtml &&
			product.descriptionHtml.search('<li>') > -1
		const soldOut = !(selectedVariant && selectedVariant.available)
		return (
			<React.Fragment>
				<Zoom zoomed={zoomed}>
					{images &&
						images.map((image, index) => {
							const id = image.id
							const resizedImage = this.getResizedImage(image, 2400)
							return (
								<div
									key={id + image.src + index + '_zoomed'}
									id={id + '_zoomed_id'}
									onClick={() =>
										this.setState({ zoomed: false }, () =>
											window.scrollTo(0, 0)
										)
									}
								>
									<Img
										fluid={{
											aspectRatio: 1,
											src: resizedImage,
											srcSet: '',
											sizes: '',
										}}
										loading="eager"
									/>
								</div>
							)
						})}
				</Zoom>
				<Wrapper>
					<Grid small="[1]" medium="[1]" large="[1] [1]">
						<SlideshowContainer>
							<Slideshow
								zoom={this.zoom}
								ids={images && images.map(({ id }) => id)}
								slides={
									images &&
									images.map((image, index) => {
										const id = image.id
										const resizedImage = this.getResizedImage(image)
										return (
											<Img
												key={id + index + '_slideshow'}
												fluid={{
													aspectRatio: 0.75,
													src: resizedImage,
													srcSet: '',
													sizes:
														'(max-width: ' +
														mq.smallBreakpoint +
														'px) 100vw, 50vw',
												}}
												loading="eager"
												onClick={() => this.zoom({ id })}
											/>
										)
									})
								}
							/>
						</SlideshowContainer>
						<ProductInfoContainer>
							<Grid small="1 [12] 1" medium="1 [12] 1" large="3 [20] 3">
								<RowCollapse>
									<Title>{product && product.title}</Title>
									<Price>{price}</Price>
								</RowCollapse>
								{product ? (
									<ProductDescription
										dangerouslySetInnerHTML={{
											__html: product.descriptionHtml,
										}}
									/>
								) : (
									''
								)}
								<div>
									<Hr />
								</div>

								{product &&
									product.options &&
									product.options.map((option, index) => {
										if (
											option.name === 'Color' &&
											(!swatches || swatches.length <= 1)
										) { return '' }
										return (
											<DetailsRow
												type="options"
												key={option.id + index + 'option_details_row'}
											>
	                      <Grid
	                        small="[12]"
	                        medium="[3] 1 [8]"
	                        large="[3] 1 [9]"
	                        vAlign="center"
	                      >
													<DetailTitle>
														{option.name}
													</DetailTitle>
													<DetailContent type="options">
														<DetailOptions>
															<OptionValues
																swatches={swatches}
																option={option}
																selectValue={this.handleSelectValue}
																checkIfAvailable={this.checkIfAvailable}
																selected={selectedOptions && selectedOptions[option.name]}
	                              // disabled='false'
															/>
														</DetailOptions>
														{(option.name === 'Size' && (sizeGuideImage || sizeChart) && !sizeFitText?.sizeFitText) && (
															<SizeGuideLink onClick={this.toggleSizeGuide}>Size Guide</SizeGuideLink>
														)}
													</DetailContent>
												</Grid>

												<Transition
													in={sizeGuideExpanded}
													key="size-guide"
													unmountOnExit={true}
													appear={false}
													timeout={{
														enter: 0,
														exit: 500
													}}
												>
													{status => (
														<SizeGuideModal transitionStatus={status}>
															<Button
																onClick={this.toggleSizeGuide}
																icon="close"
																shape="circle"
																size="small"
																setTheme="transparent"
															/>
															{sizeChart ? (
																<SizeChartPanel transitionStatus={status}>
																	<Button
																		onClick={this.toggleSizeGuide}
																		icon="close"
																		shape="circle"
																		size="small"
																		setTheme="transparent"
																	/>
																	<Grid small='1 [12] 1' larger='1 [5] 1'>
																		<SizeChartPanelContent>
																			<Img
																				fluid={{
																					aspectRatio: 1.5,
																					src: this.getResizedImage(images[0], 400),
																					sizes: '400px',
																				}}
																				loading="eager"
																			/>
																			<h4>{product.title}</h4>
																			<SizeChart richText={sizeChart.json} />
																		</SizeChartPanelContent>
																	</Grid>
																</SizeChartPanel>
															) : (
																<img src={sizeGuideImage.fixed.src} />
															)}
															<SizeChartModalOverlay onClick={this.toggleSizeGuide} transitionStatus={status} />
														</SizeGuideModal>
													)}
												</Transition>
											</DetailsRow>
										)
									})}

								{sizeFitText?.sizeFitText && (
									<ExpandDetailsRow
										icon={false}
										title={
											<DetailTitle type="expand-title">
												Size + Fit
												<MdKeyboardArrowDown size="24px" />
											</DetailTitle>
										}
									>
										<div>
											<div style={{ paddingBottom: '12px' }}>
												<p style={{ marginTop: 0, marginBottom: '.5em' }}>{sizeFitText?.sizeFitText}</p>
												{(sizeChart || sizeGuideImage) && (
													<p style={{ margin: 0 }}><a onClick={this.toggleSizeGuide}>Size Guide</a></p>
												)}
											</div>
										</div>
									</ExpandDetailsRow>
								)}

								{hasDetails && (
									<ExpandDetailsRow
										icon={false}
										title={
											<DetailTitle type="expand-title">
												Product Details
												<MdKeyboardArrowDown size="24px" />
											</DetailTitle>
										}
									>
										<div>
											{product ? (
												<DetailContent
													listOnly={true}
													dangerouslySetInnerHTML={{
														__html: product.descriptionHtml,
													}}
												/>
											) : (
												''
											)}
										</div>
									</ExpandDetailsRow>
								)}

								{shippingText && (
									<ExpandDetailsRow
										icon={false}
										title={
											<DetailTitle type="expand-title">
												Shipping + Returns
												<MdKeyboardArrowDown size="24px" />
											</DetailTitle>
										}
									>
										<ShippingTextWrapper>
											<ContentfulRichText richText={shippingText.json} />
										</ShippingTextWrapper>
									</ExpandDetailsRow>
								)}

								<ButtonWrapper>
									{status === 'coming-soon' ? (
										<>
											<ButtonATC
												size="medium"
												setTheme="blackSolid2"
												label='Coming Soon'
												onClick={() => this.setComingSoonModal(true)}
											/>
										</>
									) : (
										<>
											<ButtonATC
												size="medium"
												setTheme="blackSolid2"
												disabled={addToCartDisabled || soldOut}
												label={soldOut ? 'Sold Out' : (addToCartText || 'Add To Cart')}
												onClick={
													addToCartDisabled || soldOut ? null : this.handleAddToCart
												}
											/>

											{soldOut && (
												<div>
													<Button onClick={this.toggleNotifyModal}>
														Notify me
													</Button>
													{notifyModal && (
														<Modal
															open={notifyModal}
															// onClose={this.toggleNotifyModal}
															onClose={e => {
																this.toggleNotifyModal(e)
																this.clearNotifyStatus(e)
																this.clearNotifyEmail(e)
															}}
															position="center"
														>
															<NotifyModalBody>
																<h2>
																	We&rsquo;ll notify you as soon as this product is
																	back in stock.
																</h2>
																<Input
																	type="email"
																	placeholder="Enter Email"
																	value={this.state.notifyEmail}
																	onChange={this.handleChange}
																	name="email"
																/>
																<Button
																	setTheme="blackSolid2"
																	type="submit"
																	disabled={this.state.notifyEmail === null || this.state.notifyStatus}
																	onClick={() =>
																		this.handleBackInStockNotify(
																			this.state.notifyEmail
																		)
																	}
																>
																	Notify Me
																</Button>
																{this.state.notifyStatus && (
																	<p>{this.state.notifyStatus}</p>
																)}
															</NotifyModalBody>
														</Modal>
													)}
												</div>
											)}
										</>
									)}
								</ButtonWrapper>
							</Grid>
						</ProductInfoContainer>
					</Grid>
				</Wrapper>
				{status === 'coming-soon' && (
					<Modal open={this.state.comingSoonModal} onClose={() => this.setComingSoonModal(false)}>
						<div style={{ width: '600px', maxWidth: '80vw', textAlign: 'center', padding: '20px 0 30px 0' }}>
							<div style={{ marginBottom: '30px' }}>
								<h3 style={{ maxWidth: '14em', margin: '0 auto' }}>{comingSoonModalHeadline ? comingSoonModalHeadline : 'Sign up to find out when ' + product.title + ' is released'}</h3>
								{comingSoonModalText && <p style={{ maxWidth: '28em', margin: '1em auto 0' }}>{comingSoonModalText}</p>}
							</div>
							<FooterNewsletterSignup
								listId="RnyWsP" // Coming Soon List ID
								additionalData={{
									$fields: ['notifyAboutProduct'],
									notifyAboutProduct: product.title
								}}
							/>
						</div>
					</Modal>
				)}
			</React.Fragment>
		)
	}
}

export default withShopifyContext(withCartContext(ProductAboveTheFold))
